<template>
  <div class="companyInfoForm">
    <div class="companyInfoFormHeader">
      <h2 class="companyInfoFormTitle">完善企业信息</h2>
      <el-button
        v-if="!isEditMode && isCompleted"
        type="primary"
        size="medium"
        icon="el-icon-edit"
        class="companyInfoFormEditBtn"
        @click="isEditMode = true"
      >
        编辑
      </el-button>
    </div>
    <el-form
      ref="companyForm"
      :model="form"
      :rules="formRules"
      label-width="140px"
      :hide-required-asterisk="!isEditMode"
      class="companyInfoFormEl"
    >
      <el-row type="flex" style="flex-wrap: wrap" :gutter="24">
        <el-col :span="12">
          <el-form-item label="负责人/决策人" prop="decisionMaker">
            <div v-if="!isEditMode" class="formValue">
              {{ form.decisionMaker || "-" }}
            </div>
            <el-input
              v-else
              v-model="form.decisionMaker"
              placeholder="请输入负责人/决策人"
              maxlength="50"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="负责人联系方式" prop="decisionMakerPhone">
            <div v-if="!isEditMode" class="formValue">
              {{ form.decisionMakerPhone || "-" }}
            </div>
            <el-input
              v-else
              v-model="form.decisionMakerPhone"
              placeholder="请输入负责人联系方式"
              maxlength="20"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="公司经营地址" prop="businessAddress">
            <div v-if="!isEditMode" class="formValue">
              {{ form.businessAddress || "-" }}
            </div>
            <el-input
              v-else
              v-model="form.businessAddress"
              placeholder="请输入公司经营地址"
              maxlength="200"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="生产的盘柜类型" prop="cabinetType">
            <div v-if="!isEditMode" class="formValue">
              {{ form.cabinetType || "-" }}
            </div>
            <el-input
              v-else
              v-model="form.cabinetType"
              placeholder="请输入生产的盘柜类型"
              maxlength="100"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="主要行业" prop="mainIndustry">
            <div v-if="!isEditMode" class="formValue">
              {{ form.mainIndustry || "-" }}
            </div>
            <el-input
              v-else
              v-model="form.mainIndustry"
              placeholder="请输入主要行业"
              maxlength="100"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="主要客户" prop="mainCustomer">
            <div v-if="!isEditMode" class="formValue">
              {{ form.mainCustomer || "-" }}
            </div>
            <el-input
              v-else
              v-model="form.mainCustomer"
              placeholder="请输入主要客户"
              maxlength="100"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="人员数量" prop="staffCount">
            <div v-if="!isEditMode" class="formValue">
              {{ staffCountLabel || "-" }}
            </div>
            <el-select
              v-else
              v-model="form.staffCount"
              placeholder="请选择人员数量"
              class="companyInfoFormSelect"
            >
              <el-option
                v-for="item in staffCountOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="友商合作情况" prop="competitorCooperation">
            <div v-if="!isEditMode" class="formValue">
              {{ form.competitorCooperation || "-" }}
            </div>
            <el-input
              v-else
              v-model="form.competitorCooperation"
              placeholder="请输入友商合作情况"
              maxlength="200"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <div class="companyInfoFormFooter" v-if="isEditMode">
        <el-button
          type="primary"
          class="companyInfoFormBtn"
          :loading="submitting"
          @click="handleSubmit"
        >
          保存
        </el-button>
        <el-button
          v-if="isCompleted"
          class="companyInfoFormCancelBtn"
          @click="handleCancel"
        >
          取消
        </el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { STAFF_COUNT_OPTIONS } from "@/common/enum";

export default {
  name: "CompanyInfoForm",
  props: {
    company: {
      type: Object,
      default: () => ({}),
    },
    isCompleted: {
      type: Boolean,
      default: true,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      submitting: false,
      isEditMode: false,
      staffCountOptions: STAFF_COUNT_OPTIONS,
      form: {
        decisionMaker: "",
        decisionMakerPhone: "",
        businessAddress: "", // 公司经营地址，对接后端 businessAddress
        cabinetType: "",
        mainIndustry: "",
        mainCustomer: "",
        staffCount: "",
        competitorCooperation: "",
      },
      rules: {
        decisionMaker: [
          { required: true, message: "请输入负责人/决策人", trigger: "blur" },
        ],
        decisionMakerPhone: [
          { required: true, message: "请输入负责人联系方式", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号格式不正确",
            trigger: "blur",
          },
        ],
        businessAddress: [
          { required: true, message: "请输入公司经营地址", trigger: "blur" },
        ],
        cabinetType: [
          { required: true, message: "请输入生产的盘柜类型", trigger: "blur" },
        ],
        mainIndustry: [
          { required: true, message: "请输入主要行业", trigger: "blur" },
        ],
        mainCustomer: [
          { required: true, message: "请输入主要客户", trigger: "blur" },
        ],
        staffCount: [
          { required: true, message: "请选择人员数量", trigger: "change" },
        ],
        competitorCooperation: [
          { required: true, message: "请输入友商合作情况", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    staffCountLabel() {
      const option = this.staffCountOptions.find(
        (item) => item.value === this.form.staffCount
      );
      return option ? option.label : this.form.staffCount;
    },
    formRules() {
      return this.isEditMode ? this.rules : {};
    },
  },
  watch: {
    isCompleted: {
      handler(val) {
        if (!val) {
          this.isEditMode = true;
        }
      },
      immediate: true,
    },
    isEdit: {
      handler(val) {
        this.isEditMode = !this.isCompleted ? true : val;
      },
      immediate: true,
    },
    company: {
      handler(val) {
        this.fillFormFromCompany(val);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    fillFormFromCompany(company) {
      if (
        !company ||
        typeof company !== "object" ||
        Object.keys(company).length === 0
      ) {
        return;
      }
      this.form = {
        decisionMaker: company.decisionMaker || this.form.decisionMaker || "",
        decisionMakerPhone:
          company.decisionMakerPhone || this.form.decisionMakerPhone || "",
        // 兼容处理：支持后端返回的 businessAddress 或旧数据的 companyAddress
        businessAddress:
          company.businessAddress || company.companyAddress || "",
        cabinetType: company.cabinetType || this.form.cabinetType || "",
        mainIndustry: company.mainIndustry || this.form.mainIndustry || "",
        mainCustomer: company.mainCustomer || this.form.mainCustomer || "",
        // 兼容处理：支持后端返回的数字、数字字符串，或者遗留的描述字符串
        staffCount: (() => {
          const val =
            company.staffCount !== undefined &&
            company.staffCount !== null &&
            company.staffCount !== ""
              ? isNaN(company.staffCount)
                ? company.staffCount
                : Number(company.staffCount)
              : company.personnelNum || this.form.staffCount || "";
          return val == 0 ? "" : val;
        })(),
        competitorCooperation:
          company.competitorCooperation ||
          this.form.competitorCooperation ||
          "",
      };
    },
    handleSubmit() {
      this.$refs.companyForm.validate((valid) => {
        if (!valid) return;
        this.submitting = true;
        this.$emit("submit", { ...this.form });
        this.submitting = false;
      });
    },
    handleCancel() {
      this.isEditMode = false;
      this.fillFormFromCompany(this.company);
    },
    resetForm() {
      this.$refs.companyForm && this.$refs.companyForm.resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.companyInfoForm {
  padding: 30px 0 10px;
}
.companyInfoFormHeader {
  position: relative;
  max-width: 960px;
  margin: 0 auto 40px;
}
.companyInfoFormTitle {
  margin: 0;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 20px;
  color: #00161a;
  line-height: 28px;
  text-align: center;
}
.companyInfoFormEditBtn {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background: #00d8c3;
  border-color: #00d8c3;
  color: #fff;
  height: 36px;
  padding: 0 20px;
  border-radius: 4px;
  &:hover,
  &:focus {
    background: #00c2b0;
    border-color: #00c2b0;
    color: #fff;
  }
}
.companyInfoFormEl {
  max-width: 960px;
  margin: 0 auto;
}
.companyInfoFormSelect {
  width: 100%;
}
.formValue {
  font-family: PingFangSC, PingFang SC;
  font-size: 15px;
  color: #1a252c;
  line-height: 40px;
  min-height: 40px;
  word-break: break-all;
}
.companyInfoFormFooter {
  margin-top: 80px;
  display: flex;
  justify-content: center;
}
.companyInfoFormBtn {
  min-width: 160px;
  height: 40px;
  padding: 0 64px;
  background: #00d8c3;
  border-color: #00d8c3;
  font-size: 16px;
  &:hover,
  &:focus {
    background: #00c2b0;
    border-color: #00c2b0;
  }
}
.companyInfoFormCancelBtn {
  min-width: 160px;
  height: 40px;
  padding: 0 64px;
  margin-left: 20px;
  font-size: 16px;
  border-color: #ced9de;
  color: #525f66;
  &:hover,
  &:focus {
    border-color: #00d8c3;
    color: #00d8c3;
    background-color: #fff;
  }
}
/deep/ .el-form-item__label {
  font-size: 15px;
  color: #525f66;
  line-height: 40px;
}
/deep/ .el-form-item__label::before {
  color: #d14d21;
}
/deep/ .el-input__inner,
/deep/ .el-select .el-input__inner {
  height: 40px;
  line-height: 40px;
  border-radius: 4px;
}
</style>
